export const mediaBaseUrl = "https://backend.infooggi.it/be/api/media/";